/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Remove_Company_FailedInputs */

const en_admin_user_detail_remove_company_failed = /** @type {(inputs: Admin_User_Detail_Remove_Company_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to remove user from company`)
};

const de_admin_user_detail_remove_company_failed = /** @type {(inputs: Admin_User_Detail_Remove_Company_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfernen aus Unternehmen fehlgeschlagen`)
};

/**
* | output |
* | --- |
* | "Failed to remove user from company" |
*
* @param {Admin_User_Detail_Remove_Company_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_remove_company_failed = /** @type {((inputs?: Admin_User_Detail_Remove_Company_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Remove_Company_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_remove_company_failed(inputs)
	return en_admin_user_detail_remove_company_failed(inputs)
});